"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FLAGS = void 0;
exports.FLAGS = {
    ACTIONS_GOOGLE_EC_AUDIENCE_MEMBERSHIP: 'actions-google-ec-audience-membership',
    ACTIONS_BRAZE_COHORTS_AUDIENCE_MEMBERSHIP: 'actions-braze-cohorts-audience-membership',
    ACTIONS_LINKEDIN_AUDIENCES_AUDIENCE_MEMBERSHIP: 'actions-linkedin-audiences-audience-membership'
};
//# sourceMappingURL=flags.js.map